var _path, _path2, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 114,
    viewBox: "0 0 116 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 46.2689C0 44.5304 0.818451 42.8933 2.20917 41.8501L54.6854 2.48639C56.6495 1.01302 59.3505 1.01302 61.3146 2.48639L113.791 41.8501C115.182 42.8933 116 44.5304 116 46.2689V53.9544C116 57.0052 113.527 59.4783 110.476 59.4783H5.52381C2.47309 59.4783 0 57.0052 0 53.9544V46.2689Z",
    fill: "#B9A3EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.4924C0 45.113 1.52373 43.0009 3.78174 42.2505L56.2579 24.8109C57.3889 24.435 58.6111 24.435 59.7421 24.8109L112.218 42.2505C114.476 43.0009 116 45.113 116 47.4924V59.4783H0V47.4924Z",
    fill: "#B9A3EC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 45.1594,
    width: 116,
    height: 68.8406,
    rx: 5.52381,
    fill: "#B9A3EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4046_264470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 45,
    width: 116,
    height: 69
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 45.1594,
    width: 116,
    height: 68.8406,
    rx: 5.52381,
    fill: "#B9A3EC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4046_264470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 54.8845C0 50.5976 4.67085 47.9446 8.35284 50.1401L49.7674 74.8353C53.3604 76.9778 53.3604 82.1815 49.7674 84.324L0 114V54.8845Z",
    fill: "#C5B5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.724 54.8844C115.724 50.5975 111.053 47.9445 107.371 50.14L65.9565 74.8352C62.3635 76.9777 62.3635 82.1815 65.9565 84.324L115.724 114V54.8844Z",
    fill: "#C5B5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 114L54.6854 72.9789C56.6495 71.5055 59.3505 71.5055 61.3146 72.9789L116 114H0Z",
    fill: "#CBBAF0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.98423faa206fce62bf68d0a84c2f32ab.svg";
export { ForwardRef as ReactComponent };